import { Table, TableRow, TableCell, TableHeader } from "@tiptap/extension-table";
type PassthroughAttr = {
	default: null;
	parseHTML: (element: HTMLElement) => string | null;
	renderHTML: (attributes: Record<string, unknown>) => Record<string, string>;
};

function passthrough(attribute: string): PassthroughAttr {
	return {
		default: null,
		parseHTML: (element) => element.getAttribute(attribute),
		renderHTML: (attributes) => {
			const value = attributes[attribute];
			if (value === null || value === undefined || value === "") return {};
			return { [attribute]: String(value) };
		},
	};
}

function buildAttributes(names: string[]): Record<string, PassthroughAttr> {
	return names.reduce<Record<string, PassthroughAttr>>((acc, name) => {
		acc[name] = passthrough(name);
		return acc;
	}, {});
}

const TABLE_ATTRS = ["style", "class", "width", "border", "cellspacing", "cellpadding", "align", "bgcolor"];
const ROW_ATTRS = ["style", "class", "align", "valign", "bgcolor"];
const CELL_ATTRS = ["style", "class", "width", "height", "align", "valign", "bgcolor"];

export const CustomTable = Table.extend({
	addAttributes() {
		return {
			...this.parent?.(),
			...buildAttributes(TABLE_ATTRS),
		};
	},
});

export const CustomTableRow = TableRow.extend({
	addAttributes() {
		return {
			...this.parent?.(),
			...buildAttributes(ROW_ATTRS),
		};
	},
});

export const CustomTableCell = TableCell.extend({
	addAttributes() {
		return {
			...this.parent?.(),
			...buildAttributes(CELL_ATTRS),
		};
	},
});

export const CustomTableHeader = TableHeader.extend({
	addAttributes() {
		return {
			...this.parent?.(),
			...buildAttributes(CELL_ATTRS),
		};
	},
});
